import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { JobForm } from "@/components/admin/JobForm";
import { AdminJobList } from "@/components/admin/AdminJobList";

/** Admin → Jobs tab: post on-site jobs for signed partner technicians and pick who gets each one. */
export function AdminJobs({ draft }) {
  const [jobs, setJobs] = useState(null);
  const load = () => api.get("/admin/jobs").then((r) => setJobs(r.data)).catch(() => setJobs([]));
  useEffect(() => { load(); }, []);
  if (jobs === null) return <div className="text-slate-500 text-sm">Loading jobs…</div>;
  const open = jobs.filter((j) => j.status === "open").length;
  return (
    <div className="space-y-6" data-testid="admin-jobs">
      <JobForm draft={draft} onCreated={load} />
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="dg-eyebrow">Jobs</div>
          <span className="dg-chip text-slate-300" data-testid="admin-jobs-count">{open} open · {jobs.length - open} other</span>
          <a href="/tech" target="_blank" rel="noreferrer" className="dg-link text-xs ml-auto" data-testid="admin-jobs-board-link">Tech board: /tech ↗</a>
        </div>
        <AdminJobList jobs={jobs} onChanged={load} />
      </div>
    </div>
  );
}
